import { useMemo } from 'react'
import { useRetailerLocations } from 'api/retailerLocations/useRetailerLocations.hooks'
import { useStoreGroups } from 'domains/account-management/api/store-groups/useStoreGroups.hooks'
import { OptionType, type RetailerLocationOption, type StoreGroupOption } from './types'

export const useRetailerLocationStoreGroupSelectOptions = (retailerIds: string[]) => {
  const {
    loading: retailerLocationsLoading,
    error: retailerLocationsError,
    data: retailerLocationsData,
  } = useRetailerLocations(retailerIds, true)

  const {
    loading: storeGroupsLoading,
    error: storeGroupsError,
    data: storeGroupsData,
  } = useStoreGroups(retailerIds)

  const options = useMemo(() => {
    if (!retailerLocationsData || !storeGroupsData) return []

    const retailerLocationOptions: RetailerLocationOption[] = retailerLocationsData.map(
      partner => ({
        label: partner.name,
        value: partner.id,
        type: OptionType.RetailerLocation,
      })
    )

    const storeGroupOptions: StoreGroupOption[] = storeGroupsData?.map(storeGroup => ({
      value: storeGroup.id,
      label: storeGroup.name,
      type: OptionType.StoreGroup,
      retailerLocations: storeGroup?.retailerLocations,
    }))

    return [
      {
        label: 'Store Groups', // not shown to the user
        type: OptionType.StoreGroup,
        options: storeGroupOptions,
      },
      {
        label: 'Stores', // not shown to the user
        type: OptionType.RetailerLocation,
        options: retailerLocationOptions,
      },
    ]
  }, [retailerLocationsData, storeGroupsData])

  return {
    options,
    loading: retailerLocationsLoading || storeGroupsLoading,
    error: retailerLocationsError || storeGroupsError,
  }
}
